import React from 'react';
import { LockClosedIcon, CircleStackIcon, CodeBracketIcon, ArrowPathIcon } from '@heroicons/react/24/outline';

export type SettingsTab = 'security' | 'storage' | 'sync' | 'developer';

interface SettingsTabsProps {
  activeTab: SettingsTab;
  onTabChange: (tab: SettingsTab) => void;
}

const SettingsTabs: React.FC<SettingsTabsProps> = ({
  activeTab,
  onTabChange
}) => {
  const tabs: Array<{ id: SettingsTab; label: string; icon: React.ReactNode }> = [
    {
      id: 'security',
      label: 'Security',
      icon: <LockClosedIcon className="w-4 h-4" />
    },
    {
      id: 'storage',
      label: 'Storage',
      icon: <CircleStackIcon className="w-4 h-4" />
    },
    {
      id: 'sync',
      label: 'Sync',
      icon: <ArrowPathIcon className="w-4 h-4" />
    },
    ...(import.meta.env.VITE_SENTRY_ENVIRONMENT !== 'production' ? [{
      id: 'developer' as SettingsTab,
      label: 'Developer',
      icon: <CodeBracketIcon className="w-4 h-4" />
    }] : [])
  ];

  return (
    <div className="bg-white border-b border-gray-200 mb-6">
      <nav className="flex px-6 gap-8" aria-label="Settings tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`
              relative flex items-center py-3 text-sm font-bold transition-all duration-200 min-w-0 touch-manipulation
              ${activeTab === tab.id
                ? 'text-gray-900'
                : 'text-gray-500 hover:text-gray-700'
              }
            `}
            aria-current={activeTab === tab.id ? 'page' : undefined}
          >
            <span className="mr-1.5">{tab.icon}</span>
            <span>{tab.label}</span>
            {/* Bottom border underline for active tab */}
            {activeTab === tab.id && (
              <span className="absolute bottom-[-1px] left-0 right-0 h-[3px] bg-gray-900 rounded-full"></span>
            )}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default SettingsTabs;
